export const selectCropManagement = state => state.cropManagement.cropManagement

export const selectFertilizationProduct = state => state.cropManagement?.fertilizationProduct
